export default "__VITE_ASSET__BKpTwE_M__"